import request from '@/utils/request'

export const wellList = (params) => {
  return request({
    url: '/api/producer/getWell',
    method: 'get',
    params: params
  })
}

export const addWell = (data) => {
  return request({
    url: '/api/producer/addWell',
    method: 'post',
    data
  })
}
export const updateWell = (data) => {
  return request({
    url: '/api/producer/updateWell',
    method: 'post',
    data
  })
}

export const checkWellAvailable = (data) => {
  return request({
    url: '/api/producer/checkWellAvailable',
    method: 'post',
    data
  })
}

